import {
  CHALLENGE_USER_REPORT_COLUMNS,
  ChallengeReportReason,
} from "./challenge-user-report-column";
import DataTable from "../../../components/common/data-table/data-table";
import ChallengeUserReportForm from "./challenge-user-report-form";

interface ChallengeUserReportProps {
  userId?: String;
}

const ChallengeUserReport: React.FC<ChallengeUserReportProps> = ({
  userId,
}) => {
  return (
    <div>
      <DataTable
        tableName="Challenge Reports"
        parentTableName="Management"
        deleteTitle="Challenge Report"
        mainCol="title"
        getAllLink="/api/admin/challenge-users/report" //TODO add "api" to base rout
        getAllParameters={{ userId: userId }}
        getItemLink="/api/admin/challenge-users/report" //TODO add "api" to base rout
        updateItemLink="/api/admin/challenge-users/report" //TODO add "api" to base rout
        createItemLink="/api/admin/challenge-users/report" //TODO add "api" to base rout
        hasEdit={true}
        hasDelete={false}
        tableCols={CHALLENGE_USER_REPORT_COLUMNS}
        FormContent={ChallengeUserReportForm}
        tableDataMapper={(rows) => {
          return rows?.map((row: any, index: number) => {
            return {
              ...row,
              isParentReport: row?.isParentReport ? "Parent" : "Child",
              isDeleted: !!row?.challengeUser?.deletedAt,
              reason:
                ChallengeReportReason[
                  row.reason as keyof typeof ChallengeReportReason
                ] ?? row.reason,
            };
          });
        }}
        formDataMapper={(data: any) => {
          return {
            ...data,
            reporterType: data?.isParentReport ? "Parent" : "Child",
            reason:
              ChallengeReportReason[
                data.reason as keyof typeof ChallengeReportReason
              ] ?? data.reason,
            status: data?.status?.value,
          };
        }}
        formSubmitMapper={(data: any) => {
          return {
            status: data?.status,
          };
        }}
      />
    </div>
  );
};

export default ChallengeUserReport;
